import config from 'config';
import store from '../store';
import Utils from '../utils/utils';
import * as loginTypes from '../actions/login-actions';
import * as types from '../actions/user-actions';
import * as errorTypes from '../actions/error-actions';
import * as ticketTypes from '../actions/ticket-actions';

import LoginApi from './login-api';
import dbInstance from './dbInstace';

class UserApi {

	/**
	 * Verifies if user can play the game
	 * @param user
	 * @returns {boolean}
	 */
	static canPlay(user){
		return (user.msisdn && this.hasPlanActive(user));
	}

	/**
	 * Restore the score to normal after showNewTicketModal close
	 * @param user
	 * @returns {user}
	 */
	static restoreScore(user){
		store.dispatch({
			type: types.GET_USER_SUCCESS,
			user: user,
			wonNewTicket: false
		});

		return Promise.resolve(user);
	}

	/**
	 * Gets actual score of an user
	 * @param user
	 * @returns {int}
	 */
	static getScore(user){
		if (user.wonNewTicket) return config.application.pointsToGainTicket;
		return (user.game.score % config.application.pointsToGainTicket);
	}

	/**
	 * Verifies if user has an active plan
	 * @param user
	 * @returns {boolean}
	 */
	static hasPlanActive(user){
		if (!user || !user.subscription) return false;

		if (user.subscription.subscriptionStatus === config.constants.API.subscriptionStatus.cancelled){
			LoginApi.activationStep(config.constants.activationSteps.newUser);
			return false;
		}

		return (user.subscription.subscriptionStatus === config.constants.API.subscriptionStatus.active)
	}

	/**
	 * Gets a user by msisdn
	 */
	static getUser(msisdn, msisdnInHeader, ignoreError) {

		if (!msisdn) {
			store.dispatch({
				type: errorTypes.GET_USER_ERROR,
				error: "missingMsisdn"
			});

			return Promise.reject("missingMsisdn");
		}

		msisdn = Utils.insertMsisdnPrefix(msisdn);

		let params = {params: {msisdn}};

		return dbInstance.get(config.core.API.routes.user.getUser, params).then(response => {
			console.debug(response);

			if (response.msisdn){
				response.msisdn = Utils.removeMsisdnPrefix(response.msisdn);
			}

			store.dispatch({
				type: types.GET_USER_SUCCESS,
				user: response,
				msisdnInHeader
			});
			store.dispatch({
				type: ticketTypes.UPDATE_TICKET_LIST,
				game: response.game
			});

			return response;
		}).catch(err => {
			console.info(err);
			if (!ignoreError) {
				store.dispatch({
					type: errorTypes.GET_USER_ERROR,
					error: err
				});
			}
			return err;
		});
	}

	/**
	 * Subscribe a msisdn number
	 */
	static subscribeMsisdn(msisdn, step) {
		if (msisdn) msisdn = Utils.insertMsisdnPrefix(msisdn);

		let params = {params: {msisdn}};
		
		// Remove message Resend SMS
		if(step){
			store.dispatch({
				type: loginTypes.ACTIVATION_STEP,
				step: step,
				resendCode: false
			})
		}

		return dbInstance.get(config.core.API.routes.user.subscribe, params).then(response => {
			console.debug(response);

			Utils.gaSend('Assinatura', 'Assinar usuário', 'Sucesso', msisdn);

			//No credits
			if (response.status == "FAIL"){				
				return store.dispatch({
					type: errorTypes.SUBSCRIBE_NO_CREDITS,
					error: response.status
				});
			}

			return this.getUser(msisdn);

		}).catch(err => {
			console.info(err);

			Utils.gaSend('Assinatura', 'Assinar usuário', 'Erro', msisdn);

			//Invalid msisdn
			if(err.response != undefined && err.response.status === 400){
				store.dispatch({
					type: errorTypes.SUBSCRIBE_MSISDN_ERROR,
					error: err
				});
			}
			
			// General Error
			store.dispatch({
				type: errorTypes.SUBSCRIBE_GENERAL_ERROR,
				error: 500
			});
			
			return err;
		});
	}
}

export default UserApi;


// WEBPACK FOOTER //
// ./src/api/user-api.js